module.exports = __webpack_public_path__ + "img/tips-img-payok.e34a59fb.png";